import type { TagName } from '@/types'

export type Entity = {
  id: number | string
  createdAt?: string
  updatedAt?: string
  version?: number
}

export interface Options {
  relations?: boolean
}

export type Projection<T extends Entity> = {
  [K in keyof T]?: T[K] extends Entity[]
    ? Projection<T[K][number]>
    : T[K] extends Entity
    ? Projection<T[K]>
    : boolean
}

type DeepPickByProjection<T extends Entity, P extends Projection<T>> = {
  [K in Extract<keyof T, keyof P>]: P[K] extends boolean
    ? T[K]
    : T[K] extends Entity
    ? P[K] extends Projection<T[K]>
      ? DeepPickByProjection<T[K], P[K]>
      : never
    : never
} extends infer O
  ? { [K in keyof O]: O[K] }
  : never

export type PartialEntity<
  T extends Entity,
  U extends Projection<T>
> = DeepPickByProjection<T, U>

export interface Paging {
  limit: number
  page: number
}

export type Paged<T> = {
  data: T
  count: number
  page: number
  total: number
  pageCount: number
}

export interface Filter {
  query?: string
  tags?: TagName[]
}

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export interface SortCriteria {
  direction: SortDirection
  field: string
}
